import { render, staticRenderFns } from "./otherhistory.vue?vue&type=template&id=24dd3c48&scoped=true"
import script from "./otherhistory.vue?vue&type=script&lang=js"
export * from "./otherhistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dd3c48",
  null
  
)

export default component.exports